import { api } from '@/shared/services/api';

export interface DashboardStats {
  invoicesIssued: number;
  invoicesDraft: number;
  invoicesPaid: number;
  clientsActive: number;
  revenueThisMonth: number;
  overdueInvoices: number;
  totalInvoices: number;
}

export interface RevenueChartData {
  month: string;
  revenue: number;
  invoiceCount: number;
}

export interface RecentInvoice {
  id: string;
  series: string;
  number: string;
  type: string;
  status: string;
  total: number;
  currency: string;
  issueDate: string;
  dueDate: string | null;
  client: { id: string; name: string } | null;
  createdAt: string;
}

export interface OnboardingStatus {
  companyConfigured: boolean;
  hasClients: boolean;
  hasInvoices: boolean;
  hasEfactura: boolean;
  onboardingCompleted: boolean;
}

export interface OverdueTrendBucket {
  month: string;
  label: string;
  total: number;
  count: number;
}

export interface CollectionRateBucket {
  month: string;
  label: string;
  invoiced: number;
  collected: number;
  rate: number;
}

export interface VatSummary {
  isVatPayer: boolean;
  collected: { total: number; breakdown: Array<{ rate: number; amount: number }> };
  deductible: { total: number; breakdown: Array<{ rate: number; amount: number }> };
  toPay: number;
  declarationDeadline: string;
  daysUntilDeadline: number;
}

export const dashboardApi = {
  stats: () => api.get<DashboardStats>('/dashboard/stats'),
  revenueChart: (months = 6) => api.get<RevenueChartData[]>(`/dashboard/revenue-chart?months=${months}`),
  recentInvoices: () => api.get<RecentInvoice[]>('/dashboard/recent-invoices'),
  overdueInvoices: () => api.get<RecentInvoice[]>('/dashboard/overdue-invoices'),
  onboardingStatus: () => api.get<OnboardingStatus>('/dashboard/onboarding-status'),
  overdueTrend: () => api.get<OverdueTrendBucket[]>('/dashboard/overdue-trend'),
  collectionRate: () => api.get<CollectionRateBucket[]>('/dashboard/collection-rate'),
  vatSummary: () => api.get<VatSummary>('/dashboard/vat-summary'),
};
